<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from "@/plugins/i18n"

export default {
  setup() {
    const { t } = useI18n()
    const store = useStore()
    const step = computed(() => store.getters.step)
    const steps = ref([
      { title: t('auth.personal.register.title.text_1') },
      { title: t('auth.company.business.title.text_2') }, // business-info
      { title: t('auth.company.overview.title.text_1') }
    ])
    return { step, steps }
  }
}
</script>
<template>
  <div class="personal-auth-container">
    <div class="auth-steps">
      <div class="auth-step" :class="{'active': index <= step}" v-for="(item, index) in steps" :key="index">
        <div class="auth-step__arrow" v-if="index !== 0"></div>
        <div class="auth-step__icon">
          <span v-if="index > step">{{ index + 1 }}</span>
          <span v-else class="auth-step__success"></span>
        </div>
        <div class="auth-step__title">
          <span>{{ item.title }}</span>
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>
<style scoped lang="scss">
  .personal-auth-container {
    width: 100%;
    background-color: white;
    padding: 20px;

    .auth-steps {
      width: 100%;
      height: 60px;
      padding: 0 20px;
      background-color: rgba(146, 152, 156, 0.08);
      border-radius: 4px;
      overflow: hidden;
      box-sizing: border-box;
      display: flex;
      justify-content: center;

      .auth-step {
        /*flex: 1;*/
        overflow: hidden;
        display: flex;
        align-items: center;

        &:not(:first-child) .auth-step__icon{
          margin-left: 80px;
        }

        &:not(:last-child) .auth-step__title{
          margin-right: 80px;
        }

        & > div {
          float: left;
        }

        &.active {
          .auth-step__icon {
            border: none;
            color: #209B75;

            .auth-step__success {
              display: inline-block;
              width: 24px;
              height: 24px;
              background-image: url('../../../assets/img/auth/success.png');
              background-size: 24px 24px;
            }
          }

          .auth-step__title {
            color: #209B75;
          }
        }

        .auth-step__icon {
          width: 24px;
          height: 24px;
          min-width: 24px;
          border-radius: 24px;
          border: 1px solid #B1B1B1;
          text-align: center;
          line-height: 24px;
          color: #B1B1B1;
          box-sizing: border-box;
        }

        .auth-step__title {
          flex: 1;
          /*min-width: 100px;*/
          line-height: 60px;
          font-size: 16px;
          color: #B1B1B1;
          margin-left: 5px;
          white-space: nowrap;
        }

        .auth-step__arrow {
          /*flex: 1px;*/
          width: 140px;
          height: 0;
          border-top: 1px dashed #B1B1B1;
          opacity: .5;
        }
      }
    }
  }
</style>
